import { create } from 'zustand';
import { 
    sendTrips,
    sendTripUpsert,
    sendTripRemove
} from '../channels/tripsChannel';

import { useVehiclesStore } from './useVehiclesStore';
import { useDriversStore } from './useDriversStore';

function syncResourcesFromTrips(get, broadcast) {

    const { tripsMap } = get();

    const trips =
        Array.from(
            tripsMap.values()
        );

    useVehiclesStore
        .getState()
        .updateVeiculosEmViagem(
            trips,
            broadcast
        );

    useDriversStore
        .getState()
        .updateDriversEmViagem(
            trips,
            broadcast
        );

}

export const useTripsStore = create((set, get) => ({
    
    tripsMap: new Map(),

    tripsCacheUserId: null,

    setTrips: (trips = [], broadcast = true) => {

        set(state => {

            const tripsMap = new Map(state.tripsMap);

            for (const trip of trips) {

                if (!trip?.TRIP_UID) {
                    continue;
                }

                tripsMap.set(
                    String(trip.TRIP_UID),
                    trip
                );

            }

            return {
                tripsMap
            };

        });

        syncResourcesFromTrips(get, broadcast);

        if (broadcast) {
            sendTrips(trips);
        }

    },

    upsertTrip: (trip, broadcast = true) => {

        if (!trip?.TRIP_UID) {
            return;
        }

        set(state => {

            const tripsMap =
                new Map(state.tripsMap);

            tripsMap.set(
                String(trip.TRIP_UID),
                trip
            );

            return {
                tripsMap
            };

        });

        syncResourcesFromTrips(get, broadcast);

        if (broadcast) {
            sendTripUpsert(trip);
        }

    },

    removeTrip: (tripUid, broadcast = true) => {

        set(state => {

            const tripsMap =
                new Map(state.tripsMap);

            tripsMap.delete(
                String(tripUid)
            );

            return {
                tripsMap
            };

        });

        syncResourcesFromTrips(get, broadcast);

        if (broadcast) {
            sendTripRemove(tripUid);
        }

    },

    getLoadedCodesByDate: (date) => {

        const codigos = new Set();

        for (const trip of get().tripsMap.values()) {

            if (
                String(trip.DATA_REFERENCIA) === String(date)
            ) {
                codigos.add(
                    String(trip.CODIGO_INTEGRACAO)
                );
            }

        }

        return codigos;
    },

    setTripsCacheUserId: (userId) => {
        set({
            tripsCacheUserId:
                userId != null
                    ? String(userId)
                    : null
        });
    },

    resetTrips: () => {

        set({
            tripsMap: new Map()
        });

        syncResourcesFromTrips(get, false);

    },

}));